import { optionTitle_composeAssistance } from './ComposeAssistanceOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserCulture } from 'owa-session-store';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));

let ComposeAssistanceOption: LazyOption = createLazyOption(
    {
        key: 'composeAssistance',
        titleStringKey: optionTitle_composeAssistance,
        searchTermsStringKey: optionTitle_composeAssistance,
        isHidden: () =>
            // This code is duplicated to the file isSmartComposeEnabled. WI to remove it 51333
            !(
                isFeatureEnabled('mc-smartCompose') &&
                (getUserCulture() === 'en-US' ||
                    getUserCulture() === 'en-CA' ||
                    getUserCulture() === 'en-AU' ||
                    getUserCulture() === 'en-GB' ||
                    getUserCulture() === 'en-NZ')
            ),
    },
    lazyFullModule,
    m => m.default
);
export default ComposeAssistanceOption;
